import styled, { createGlobalStyle, css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

const { sky, blue } = colorsPalettes;

export const GlobalStyles = createGlobalStyle`

    .title-tooltip, .sw-tooltip {
        max-width: 230px ;
    }
`;

export const Container = styled.div`
    width: 100%;
`;

export const CarouselWrapper = styled.div`
    position: relative;
    width: 100%;
    box-sizing: border-box;
    background: ${sky[100]};
    padding: 8px;
    box-shadow: 0 3px 6px 0 rgba(14, 30, 62, 0.08);
    border-radius: 6px;

    .carouselItemWrapper {
        width: 100%;
    }
`;

export const CarouselDisabledContainer = styled.div<{ isDisabled?: boolean }>`
    ${({ isDisabled = false }) =>
        isDisabled
            ? css`
                  position: absolute;
                  top: 36px;
                  left: 8px;
                  right: 8px;
                  bottom: 8px;

                  border-radius: 4px;
                  background: linear-gradient(180deg, rgba(255, 255, 255, 0.6) 0%, ${blue[50]} 100%);
              `
            : css`
                  display: none;
              `}
`;

export const CarouselHeader = styled(FlexRow)`
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;

    ${setFontVariant("subtitle2", colorsPalettes.carbon[400])}
`;

export const CreateButtonContainer = styled.div`
    position: absolute;
    top: calc(50% + 12px);
    left: 50%;
    transform: translate(-50%, -50%);

    z-index: 10;
`;
